// extracted by mini-css-extract-plugin
module.exports = {"container":"ConfettiAnimation_container__2tVwj"};